"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var CacheNode_1 = require("./CacheNode");
/**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */
var NoCompleteChildSource_ = /** @class */ (function () {
 function NoCompleteChildSource_() {
 }
 /**
 * @inheritDoc
 */
 NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
 return null;
 };
 /**
 * @inheritDoc
 */
 NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
 return null;
 };
 return NoCompleteChildSource_;
}());
exports.NoCompleteChildSource_ = NoCompleteChildSource_;
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */
exports.NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */
var WriteTreeCompleteChildSource = /** @class */ (function () {
 /**
 * @param {!WriteTreeRef} writes_
 * @param {!ViewCache} viewCache_
 * @param {?Node} optCompleteServerCache_
 */
 function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
 if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
 this.writes_ = writes_;
 this.viewCache_ = viewCache_;
 this.optCompleteServerCache_ = optCompleteServerCache_;
 }
 /**
 * @inheritDoc
 */
 WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
 var node = this.viewCache_.getEventCache();
 if (node.isCompleteForChild(childKey)) {
 return node.getNode().getImmediateChild(childKey);
 }
 else {
 var serverNode = this.optCompleteServerCache_ != null
 ? new CacheNode_1.CacheNode(this.optCompleteServerCache_, true, false)
 : this.viewCache_.getServerCache();
 return this.writes_.calcCompleteChild(childKey, serverNode);
 }
 };
 /**
 * @inheritDoc
 */
 WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
 var completeServerData = this.optCompleteServerCache_ != null
 ? this.optCompleteServerCache_
 : this.viewCache_.getCompleteServerSnap();
 var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
 if (nodes.length === 0) {
 return null;
 }
 else {
 return nodes[0];
 }
 };
 return WriteTreeCompleteChildSource;
}());
exports.WriteTreeCompleteChildSource = WriteTreeCompleteChildSource;

//# sourceMappingURL=CompleteChildSource.js.map



//////////////////
// WEBPACK FOOTER
// ../database/dist/cjs/src/core/view/CompleteChildSource.js
// module id = 93
// module chunks = 0